import { Injectable } from '@angular/core';
import { ethers } from 'ethers';
import { AllChains, ChainEnum, getChainInfo } from '../shared/types/wallet-chain.type';
import { RequestService } from './request.service';
import { WalletStatusService } from './wallet-status.service';

const CHAIN_LIST = AllChains;

const lineaContractABI = [
    {
        inputs: [
            { internalType: 'string', name: 'name_', type: 'string' },
            { internalType: 'string', name: 'symbol_', type: 'string' },
            { internalType: 'bool', name: 'publicMint', type: 'bool' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'approved', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'address', name: 'account', type: 'address' }],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
            { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'address', name: 'account', type: 'address' }],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'PAUSER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'getApproved',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'getInfoHash',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'address', name: 'operator', type: 'address' },
        ],
        name: 'isApprovedForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address[]', name: 'to', type: 'address[]' },
            { internalType: 'uint256[]', name: 'tokenId', type: 'uint256[]' },
            { internalType: 'string[]', name: 'uri', type: 'string[]' },
        ],
        name: 'mintMultiple',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'signer', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenID', type: 'uint256' },
            { internalType: 'string', name: 'uri', type: 'string' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'mintWithSignature',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'string', name: 'uri', type: 'string' },
        ],
        name: 'mintWithTokenURI',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'ownerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    { inputs: [], name: 'pause', outputs: [], stateMutability: 'nonpayable', type: 'function' },
    { inputs: [], name: 'paused', outputs: [{ internalType: 'bool', name: '', type: 'bool' }], stateMutability: 'view', type: 'function' },
    { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'safeTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        name: 'safeTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'operator', type: 'address' },
            { internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
        name: 'tokenByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'tokenURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'tokensOfOwner',
        outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    { inputs: [], name: 'unpause', outputs: [], stateMutability: 'nonpayable', type: 'function' },
];
const ultiverseContractABI = [
    {
        inputs: [
            { internalType: 'string', name: 'name_', type: 'string' },
            { internalType: 'string', name: 'symbol_', type: 'string' },
            { internalType: 'bool', name: 'publicMint', type: 'bool' },
        ],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'approved', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'previousOwner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'newOwner', type: 'address' },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'address', name: 'account', type: 'address' }],
        name: 'Paused',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'bytes32', name: 'previousAdminRole', type: 'bytes32' },
            { indexed: true, internalType: 'bytes32', name: 'newAdminRole', type: 'bytes32' },
        ],
        name: 'RoleAdminChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleGranted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: true, internalType: 'address', name: 'sender', type: 'address' },
        ],
        name: 'RoleRevoked',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [{ indexed: false, internalType: 'address', name: 'account', type: 'address' }],
        name: 'Unpaused',
        type: 'event',
    },
    {
        inputs: [],
        name: 'DEFAULT_ADMIN_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'MINTER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'PAUSER_ROLE',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'baseURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'message', type: 'string' },
            { internalType: 'address', name: 'signer', type: 'address' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'checkInWithSignature',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: 'message', type: 'string' },
            { internalType: 'address', name: 'signer', type: 'address' },
            { internalType: 'uint256', name: 'signDate', type: 'uint256' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'checkInWithSignature',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: 'timestamp1', type: 'uint256' },
            { internalType: 'uint256', name: 'timestamp2', type: 'uint256' },
        ],
        name: 'compareDates',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'getApproved',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getCurrentTime',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_attendee', type: 'address' },
            { internalType: 'string', name: '_message', type: 'string' },
        ],
        name: 'getInfoHash',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_attendee', type: 'address' },
            { internalType: 'uint256', name: '_signDate', type: 'uint256' },
            { internalType: 'string', name: '_message', type: 'string' },
        ],
        name: 'getInfoHash',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_signDate', type: 'uint256' },
        ],
        name: 'getMintHash',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes32', name: 'role', type: 'bytes32' }],
        name: 'getRoleAdmin',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'grantRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'hasRole',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'address', name: 'operator', type: 'address' },
        ],
        name: 'isApprovedForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'signer', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'signDate', type: 'uint256' },
            { internalType: 'bytes', name: 'signature', type: 'bytes' },
        ],
        name: 'mintWithSignature',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'ownerMint',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'ownerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    { inputs: [], name: 'pause', outputs: [], stateMutability: 'nonpayable', type: 'function' },
    { inputs: [], name: 'paused', outputs: [{ internalType: 'bool', name: '', type: 'bool' }], stateMutability: 'view', type: 'function' },
    { inputs: [], name: 'renounceOwnership', outputs: [], stateMutability: 'nonpayable', type: 'function' },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'renounceRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'bytes32', name: 'role', type: 'bytes32' },
            { internalType: 'address', name: 'account', type: 'address' },
        ],
        name: 'revokeRole',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'safeTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        name: 'safeTransfer',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'operator', type: 'address' },
            { internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: 'baseURI', type: 'string' }],
        name: 'setBaseURI',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: 'interfaceId', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'index', type: 'uint256' }],
        name: 'tokenByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'owner', type: 'address' },
            { internalType: 'uint256', name: 'index', type: 'uint256' },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: 'tokenId', type: 'uint256' }],
        name: 'tokenURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'owner', type: 'address' }],
        name: 'tokensOfOwner',
        outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: 'from', type: 'address' },
            { internalType: 'address', name: 'to', type: 'address' },
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: 'newOwner', type: 'address' }],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    { inputs: [], name: 'unpause', outputs: [], stateMutability: 'nonpayable', type: 'function' },
];

export type BadeType = 'linea_data_scanner' | 'linea_gang' | 'ultiverse_ai_day' | 'ultiverse_gang';

@Injectable({
    providedIn: 'root',
})
export class EthersRequestService {
    ethereumProvider: ethers.JsonRpcProvider;
    mantleProvider: ethers.JsonRpcProvider;
    polygonProvider: ethers.JsonRpcProvider;
    zkevmProvider: ethers.JsonRpcProvider;
    lineaProvider: ethers.JsonRpcProvider;
    baseProvider: ethers.JsonRpcProvider;
    mantaPacificProvider: ethers.JsonRpcProvider;
    opProvider: ethers.JsonRpcProvider;
    avalancheCProvider: ethers.JsonRpcProvider;
    arbitrumProvider: ethers.JsonRpcProvider;
    blastProvider: ethers.JsonRpcProvider;
    bscTestNetProvider: ethers.JsonRpcProvider;

    constructor(private walletStatusService: WalletStatusService, private requestService: RequestService) {}

    initProvider() {
        this.ethereumProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.ETHEREUM).infoUsedConnectWallet.rpcUrls[0]);
        this.mantleProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.MANTLE).infoUsedConnectWallet.rpcUrls[0]);
        this.polygonProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.POLYGON).infoUsedConnectWallet.rpcUrls[0]);
        this.zkevmProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.POLYGON_ZKEVM).infoUsedConnectWallet.rpcUrls[0]);
        this.lineaProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.LINEA).infoUsedConnectWallet.rpcUrls[0]);
        this.baseProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.BASE).infoUsedConnectWallet.rpcUrls[0]);
        this.mantaPacificProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.MANTA_PACIFIC).infoUsedConnectWallet.rpcUrls[0]);
        this.opProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.OP).infoUsedConnectWallet.rpcUrls[0]);
        this.avalancheCProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.AVALANCHE_C).infoUsedConnectWallet.rpcUrls[0]);
        this.arbitrumProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.ARBITRUM).infoUsedConnectWallet.rpcUrls[0]);
        this.blastProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.BLAST).infoUsedConnectWallet.rpcUrls[0]);
        this.bscTestNetProvider = new ethers.JsonRpcProvider(getChainInfo(ChainEnum.BNB_TESTNET).infoUsedConnectWallet.rpcUrls[0]);
    }

    async getAddressBalance(address: string, chain: ChainEnum): Promise<string> {
        switch (chain) {
            case ChainEnum.ETHEREUM:
            case ChainEnum.ETHEREUM_FULL:
                return this.ethereumProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.MANTLE:
                return this.mantleProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.POLYGON:
                return this.polygonProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.POLYGON_ZKEVM:
                return this.zkevmProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.LINEA:
                return this.lineaProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.BASE:
                return this.baseProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.MANTA_PACIFIC:
                return this.mantaPacificProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.OP:
                return this.opProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.ARBITRUM:
                return this.arbitrumProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.AVALANCHE_C:
                return this.avalancheCProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.BLAST:
                return this.blastProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            case ChainEnum.BNB_TESTNET:
                return this.bscTestNetProvider.getBalance(address).then(balance => ethers.formatEther(balance));
            default:
                console.error('Unsupported chain');
                return null;
        }
    }

    async getAddressAllChainBalance(address: string): Promise<{ [key: string]: string }> {
        return Promise.allSettled(CHAIN_LIST.map(chain => this.getAddressBalance(address, chain))).then(data => {
            const balances: { [key: string]: string } = {};

            data.forEach((item, index) => {
                balances[CHAIN_LIST[index]] = item.status === 'fulfilled' ? item.value : '0';
            });

            return balances;
        });
    }

    async mintBadge(badge: BadeType) {
        const provider = new ethers.BrowserProvider(this.walletStatusService.getProvider());

        const signResult = await this.getMintBadgeSignature(badge);

        await this.switchNetwork(provider, signResult.chain);

        const contractAbi = ['linea_data_scanner', 'linea_gang'].includes(badge) ? lineaContractABI : ultiverseContractABI;

        const { contract } = await this.getDaiContract(signResult.contract_address, contractAbi, {
            provider: provider,
            requestSign: true,
        });

        let gasEstimate = ['linea_data_scanner', 'linea_gang'].includes(badge) ? 300000 : 200000;

        const params = ['linea_data_scanner', 'linea_gang'].includes(badge)
            ? [signResult.signer_address, signResult.wallet_address, signResult.token_id, signResult.token_uri, signResult.signed_message]
            : [signResult.signer_address, signResult.wallet_address, signResult.sign_date, signResult.signed_message];
        try {
            gasEstimate = await (contract['estimateGas'] as any)['mintWithSignature'](...params);
        } catch {
            console.error('estimateGas error');
        }

        const tx = contract['mintWithSignature'](...params, {
            gasLimit: gasEstimate,
        });

        return tx.then(async transaction => {
            // 等待交易被挖掘
            await transaction.wait();
            return await this.mintOnChainBadge(signResult.token_id, transaction.hash, badge);
        });
    }

    async getDaiContract(
        daiAddress: string,
        daiAbi: ethers.InterfaceAbi,
        params?: {
            provider?: any;
            requestSign?: boolean;
        }
    ) {
        let provider = params?.provider;
        let signer: ethers.Wallet = null;

        if (!params?.provider) {
            provider = new ethers.BrowserProvider(window.ethereum as any);
        }

        if (params?.requestSign) {
            signer = await provider?.getSigner();
        }

        return {
            contract: new ethers.Contract(daiAddress, daiAbi, params?.requestSign ? signer : provider),
            signer,
        };
    }

    mintOnChainBadge(token_id: number, transaction_hash: string, badge_type: BadeType) {
        return this.requestService.sendRequest<any>({
            method: 'POST',
            url: '/v1/socialscan/user/task/mint_onchain_badge',
            data: {
                token_id,
                transaction_hash,
                badge_type,
            },
        });
    }

    getMintBadgeSignature(badge: BadeType) {
        return this.requestService.sendRequest<{
            token_id: number;
            token_uri: string;
            signed_message: string;
            wallet_address: string;
            contract_address: string;
            signer_address: string;
            chain: ChainEnum;
            sign_date?: number;
        }>({
            method: 'POST',
            url: '/v1/socialscan/user/task/sign_mint_badge',
            data: { badge_type: badge },
        });
    }

    async switchNetwork(provider: any, chain: ChainEnum) {
        const chainInfo = getChainInfo(chain);

        try {
            if (provider.request) {
                await provider.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: chainInfo.infoUsedConnectWallet.chainId }],
                });
            } else if (provider.send) {
                await provider.send('wallet_switchEthereumChain', [{ chainId: chainInfo.infoUsedConnectWallet.chainId }]);
            } else {
                throw new Error('Provider does not support network switching');
            }
        } catch (switchError: any) {
            console.log('switchError:', switchError);

            if (
                switchError.code === 4902 ||
                switchError.code === -32603 ||
                (switchError.data && switchError.data.originalError && switchError.data.originalError.code === 4902)
            ) {
                try {
                    if (provider.request) {
                        await provider.request({
                            method: 'wallet_addEthereumChain',
                            params: [chainInfo.infoUsedConnectWallet],
                        });
                    } else if (provider.send) {
                        await provider.send('wallet_addEthereumChain', [chainInfo.infoUsedConnectWallet]);
                    } else {
                        throw new Error('Provider does not support adding new networks');
                    }

                    // 添加网络后，再次尝试切换
                    await this.switchNetwork(provider, chain);
                } catch (addError: any) {
                    console.error('Error adding the network:', addError);
                    throw new Error('Failed to add the network. Please add it manually.');
                }
            } else {
                console.error('Failed to switch network:', switchError);
                throw new Error('Network switch failed. Please try again or switch manually.');
            }
        }

        // 等待一段时间确保网络切换完成
        await new Promise(resolve => setTimeout(resolve, 1000));
    }
}
